<template>
  <div class="sys-sty">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="sys-c" v-for="(item,index) in dataList" :key="index" @click="onClick(item)">
          <div class="c-left">
            <img v-if="item.title=='订单进度更新'" class="icon-s icon4" src="./img/icon4.png" alt />
            <img v-if="item.title=='邀请通知'" class="icon-s icon5" src="./img/icon5.png" alt />
          </div>
          <div class="c-right">
            <div class="c-tit">
              <div class="title-div">{{item.title}}</div>
              <div class="time-div">{{item.time}}</div>
            </div>
            <div class="con-div">{{item.content}}</div>
          </div>
          <p v-if="item.type==0" class="p-sty"></p>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import { Toast } from 'vant';
export default {
  props: ['checkLi'],
  data() {
    return {
      page: 1,//当前页
      size: 10,//每页条数
      total: 0,//总数据条数
      loading: false,//将 loading 设置为 true，表示处于加载状态
      finished: false,//是否已加载完成，加载完成后不再触发load事件
      refreshing: false,
      dataList: [],
    }
  },
  methods: {
    //下拉刷新
    onRefresh() {
      this.page = 1
      this.finished = false
      this.loading = true;
      this.getData()
    },
    onLoad() {//初始加载
      this.getData()
    },
    //数据
    getData() {
      let that = this
      let data = {
        userId: localStorage.getItem('userid'),
        typeCode: that.checkLi,//system系统消息,business业务,activity活动
        page: that.page,
        size: that.size
      }
      that.$fetchGet(URLTB.getMessage.url, data).then(res => {
        if (res.data.code == 20000) {
          that.refreshing = false
          that.loading = false
          let list = res.data.data.data.records
          that.total = res.data.data.data.total
          that.messageCount = res.data.data.unread
          if (list == null || list.length == 0) {
            //加载结束
            that.finished = true
            return
          }
          //将新数据与老数据进行合并
          if (that.page > 1) {
            that.dataList = [...that.dataList, ...list]
          } else {
            that.dataList = list
          }
          //如果列表数据条数>=总数据条数，不再触发loading加载
          if (that.size * that.page >= that.total) {
            that.finished = true
            return
          }
          //如果如果列表数据条数<总数据条数,页数加一
          if (that.size * that.page < that.total) {
            that.page++
          }
        }

      })
    },
    onClick(item) {
      if (item.title == '订单') {
        this.$router.push({ path: '/loanOrderDetail', query: { id: item.bid } })
      } else if (item.title == '邀请') {
        this.$router.push({ path: '/myTeam', query: { id: item.bid }  })
      }else {
        Toast(item.message)
      }
      this.$parent.changeStatus(item.id)
    }
  }
}
</script>

<style lang="less" scoped>
.sys-sty {
  .sys-c {
    width: 355px;
    height: 100px;
    margin: 15px auto auto;
    background: url("../../assets/publicImg/con-bg.png") no-repeat 50%;
    background-size: 100% 100%;
    display: flex;
    position: relative;
    .c-left {
      width: 65px;
      text-align: center;
      .icon-s {
        width: 42px;
        margin-top: 16px;
      }
    }
    .c-right {
      width: 247px;
      .c-tit {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        color: #333333;
        .title-div {
          font-size: 14px;
          font-weight: 500;
        }
        .time-div {
          font-size: 11px;
          font-weight: 400;
        }
      }
      .con-div {
        margin-top: 15px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
      }
    }
    .p-sty {
      width: 5px;
      height: 5px;
      background: #fc6e09;
      border-radius: 50%;
      position: absolute;
      top: 16px;
      right: 15px;
    }
  }
}
</style>